export const combiningDiacriticsRegex = /[\u0300-\u036f]/g;
